export default "__VITE_ASSET__BJRzwAhL__";